<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    스트리밍 상세
                </div>
                <div class="list-content content tab-content">
                    <div
                        class="intro_tab col_2"
                        @click="moveDetail()"
                    >
                        상세 정보
                    </div>
                    <div
                        class="intro_tab col_2 active"
                    >
                        수강학생
                    </div>
                </div>
                <div class="list-content">
                    <streaming-list-component :streamingType="'streamingStudent'"
                                               :streamingKey="streamingKey"
                                               :liveKlassKey="liveKlassKey"></streaming-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

        </div>
        <live-class-member-list-modal></live-class-member-list-modal>
    </div>
</template>

<script>
import StreamingWriteComponent from "@/components/streaming/StreamingWriteComponent";
import EventBus from "@/utils/event-bus";
import StreamingListComponent from "@/components/streaming/StreamingListComponent";
import LiveClassMemberListModal from "@/components/modal/LiveClassMemberListModal";
import util from "@/mixins/util";

export default {
    name: 'LiveKlassStreamingDetailStudent',
    mixins: [],
    components: {StreamingWriteComponent, StreamingListComponent, LiveClassMemberListModal},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            liveKlassKey: Number(this.$route.params.idx),
            streamingKey: Number(this.$route.params.s_idx),
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        write() {
            EventBus.$emit("writeStreaming", false);
        },
        statusUpdate() {
            EventBus.$emit("writeStreaming", true);
        },
        remove() {
            EventBus.$emit("removeStreaming");
        },
        moveDetail() {
            this.$router.push(`/content/liveklass/${this.liveKlassKey}/streaming/${this.streamingKey}`);
        },
    },
    watch: {
        "$route.path": {
            deep: true,
            handler: function (val, oldVal) {
                if (
                    !util.isEmpty(this.$route.query.tab) &&
                    this.tab != this.$route.query.tab
                ) {
                    this.changeTab(this.$route.query.tab);
                }
            },
        },
    },
}
</script>
